import { IRootState } from './index';
import { IInvoiceState } from './invoice.types';

export const selectInvoice = ({ invoice }: IRootState): IInvoiceState => invoice;
